export default {
  SET_COMPANIES (state, companies) {
    state.companies = companies
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.companies.findIndex((u) => u.id === itemId)
    state.companies.splice(roleIndex, 1)
  }
}
